
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { openMiniProgram } from '@xt/client/utils/mini'
import { EnumOpenMiniProgramType, EnumOpenMiniProgramPage } from '@xt/client/enums/mini'

@Observer
@Component({
  components: {}
})
export default class ContentFooter extends Vue {
  @Prop({ required: true }) placeholder: string

  @Prop({ required: true }) commentDisabled: boolean

  @Prop({ required: true }) shareDisabled: boolean

  get UserStore() {
    return this.$store.$storeUser.UserInfo
  }

  get UserContent() {
    return this.$store.$courseV2.UserContent
  }

  async handleOpenPCMini() {
    const { content, isVideo, fullOptions } = this.UserContent

    if (!fullOptions || !content) return

    const { success, reason } = await openMiniProgram(
      EnumOpenMiniProgramType.Uc,
      isVideo ? EnumOpenMiniProgramPage.UcVideoContent : EnumOpenMiniProgramPage.UserContent,
      isVideo
        ? { id: content.contentId }
        : fullOptions.type === 'homework'
          ? { homeworkId: content.contentId, type: fullOptions.type }
          : { momentId: content.contentId, type: fullOptions.type }
    )

    console.warn(success, reason)

    if (reason) {
      this.$message.error(reason)
    }
  }

  handleClick() {
    if (!this.UserStore.id) {
      this.$emit('unauthorized')
      return
    }

    if (this.commentDisabled) {
      this.$message.error('作业未评阅')
      return
    }

    this.$emit('click-comment')
  }

  async handleLike() {
    if (!this.UserStore.id) {
      this.$emit('unauthorized')
      return
    }

    if (this.UserContent.content?.allowLikeOrCollect === false) {
      return
    }

    if (this.UserContent.content?.isLike) {
      this.$message.error('你已经点过赞了')
      return
    }

    const isSuccess = await this.UserContent.likeMoment()

    if (isSuccess) {
      this.$message.success('点赞成功')
      this.$emit('like-success')
    }
  }

  async handleCollect() {
    if (!this.UserStore.id) {
      this.$emit('unauthorized')
      return
    }

    if (this.UserContent.content?.allowLikeOrCollect === false) {
      return
    }

    const { isSuccess, type } = await this.UserContent.collectMoment()

    if (isSuccess) {
      this.$message.success(type === 'collect' ? '收藏成功' : '取消收藏成功')
    }
  }

  async handleVisibleChange(isShow: boolean) {
    if (!this.UserStore.id) {
      this.$emit('unauthorized')
      return
    }

    if (this.shareDisabled) return

    if (isShow) {
      await this.UserContent.loadContentShareImage()
    } else {
      this.UserContent.revokeShareImage()
    }
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
